<template>
  <div>
    <div class="sec-banner">
      <img src="../../assets/01.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "sec-banner",
  props: {},
  computed: {},
  methods: {}
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/assembly/sec-banner.vue